module.exports = __webpack_public_path__ + "img/fuwu.1a6923e7.jpg";